module.exports = {
  "下载":"Télécharger",
  "打开":"Ouvrir",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"Mon équipe",
    "wdyj":"Ma performance",
    "ren":"personne",
  },
  "kjsy": {
    "title":"Chiffre d'affaires",
    "fxsy":"Partager les revenus",
    "zjlsl":"Montant total de la récompense",
    "jl":"Récompense",
    "sj":"Date",
    "sl":"Quantité",
    "sm":"Description",
  },
  pay:{//purchase
    "title":"Acheter une machine de minage",
    "gmsl":"Quantité achetée",
    "zf":"Paiement",
    "kyye":"Solde disponible",
    "kyyebz":"Solde disponible insuffisant",
    "bztbtips":"Le montant du retrait saisi est inférieur au montant minimum de retrait requis pour cette devise",
    "bztbtips2":"Le montant du retrait ne peut pas être inférieur au montant minimum de retrait",
    "qsrjymm":"Veuillez saisir un mot de passe de transaction à 6 chiffres",
    "wxts":"Rappel",
  },
  chongbi:{
    "title":"Dépôt",
    "lianmc":"Type de chaîne",
    "scl":"Générer une chaîne exclusive",
    "sy":"Clé privée",
    "ewm":"Code QR",
    "bcewm":"Enregistrer le code QR",
    "cbdz":"Adresse de dépôt",
    "fz":"Copier",
    "sl":"Montant du dépôt",
    "qsrsl":"Veuillez saisir le montant du dépôt",
    "sjczje":"Montant réel de la recharge",
    "qsrsjczje":"Veuillez saisir le montant réel de la recharge",
    "pzms":"Description du certificat",
    "qsrms":"Veuillez saisir une description",
    "hxz":"Valeur de hachage",
    "qsrhxz":"Veuillez saisir la valeur de hachage",
    "pztp":"Image du bon",
    "qscpztp":"Veuillez télécharger l'image du certificat",
    "fzcg":"Copie réussie",
    "yhkcz":"Recharge de carte bancaire",
    "usdtcz":"Recharge USDT",
    "btccz":"Recharge BTC",
    "xzbz":"Sélectionner la devise",
    "sure":"Confirmer",
    "ck":"Afficher",
    "tips1":"Veuillez ne pas recharger d'actifs qui ne sont pas dans cette devise à l'adresse ci-dessus, sinon les actifs ne pourront pas être récupérés",
    "tips2":"1. Votre réseau d'envoi et la plateforme cible sont cohérents ; si vous choisissez le réseau Ethereum comme adresse cible, vous devez sélectionner la chaîne intelligente correspondante lors de l'envoi. En cas d'erreur, vous ne pourrez pas récupérer vos actifs numériques.",
    "tips3":"2. Assurez-vous que votre adresse et votre réseau sont cohérents avant l'envoi.",
    "tips4":"Rappel chaleureux : en raison de l'anonymat et de la confidentialité du réseau blockchain, une fois que vous aurez saisi des informations incorrectes, vous perdrez les actifs correspondants. Assurez-vous de vérifier votre adresse de livraison.",
  },
  usdttb:{
    "title":"Retirer",
    "lmc":"Type de chaîne",
    "xzl":"Sélectionner la chaîne",
    "xztbdz":"Sélectionner l'adresse de retrait",
    "qsrtbdz":"Veuillez saisir l'adresse de retrait",
    "tbdz":"adresse de retrait",
    "qsrdz":"Veuillez saisir l'adresse",
    "tbsl":"Montant du retrait",
    "tbsl2":"Montant du retrait",
    "qsrtbsl":"Veuillez saisir le montant du retrait",
    "sjtxje":"Montant réel du retrait",
    "qsrsjtxje":"Veuillez saisir le montant réel du retrait",
    "dzje":"Montant du compte",
    "jymm":"Mot de passe de transaction",
    "qsrjymm":"Veuillez saisir le mot de passe de transaction",
    "sxf":"Frais de traitement",
    "qsrsxf":"Veuillez saisir les frais de traitement",
    "dzsl":"Montant du compte",
    "dzsl2":"Montant du compte reçu :",
    "qsrdzsl":"Veuillez saisir le montant du compte",
    "wxts":"Rappel :",
    "mrzdtxcs":"Montant minimum de retrait à chaque fois :",
    "hxxf":"Besoin de consommer",
    "cktx":"Disponible uniquement pour le retrait",
    "ci":"Heures",
    "wddtxyq":"Conditions de retrait non remplies",
    "tjcg":"Soumission réussie, veuillez attendre la révision",
    "tips":"Vous ne pouvez retirer des pièces que si votre propre puissance de calcul est supérieure à 1 T (à l'exception de la puissance de calcul de la machine d'exploration d'expérience) ou si la puissance de calcul sous l'égide est supérieure à 50 T.",
    "dz":"Adresse",
    "qd":"OK",
    "zdtb":"Retrait minimum",
  },
  kefu: {
    "title":"Contacter le service client",
    "zxkf":"Service client",
    "fzcg":"Copie réussie",
  },
  xgdlmm:{//Modify login password
    "title":"Modifier le mot de passe de connexion",
    "t1":"Mot de passe de connexion actuel",
    "t2":"Veuillez saisir le mot de passe de connexion actuel",
    "t3":"Nouveau mot de passe",
    "t4":"Veuillez saisir 6 à 16 chiffres et lettres",
    "t5":"Confirmer le mot de passe",
    "t6":"Veuillez saisir 6 à 16 chiffres et lettres",
    "t7":"Confirmer",
    "t8":"Le mot de passe est incompatible avec le mot de passe de confirmation",
    "mm":"Mot de passe",
    "qsrmm":"Veuillez saisir votre mot de passe",
    "qqrmm":"Veuillez confirmer votre mot de passe",
    "qsrsjh":"Numéro de téléphone portable",
    "zc":"Inscription",
    "mmts":"Longueur du mot de passe 6-12 caractères",
  },
  sztxmm:{//Set withdrawal password
    "title":"Modifier le mot de passe de transaction",
    "wjtkmm":"Mot de passe de transaction oublié",
    "qsrjdlmm":"Veuillez saisir le mot de passe de transaction actuel",
    "zh":"Compte",
    "qsryxhzsj":"Veuillez saisir votre adresse e-mail ou votre téléphone portable",
    "t1":"Mot de passe de transaction actuel",
    "t2":"Nouveau mot de passe de transaction",
    "t3":"Veuillez saisir le mot de passe de transaction à 6 chiffres",
    "t4":"Confirmer le mot de passe",
    "t5":"Vous avez oublié le mot de passe de transaction ?",
    "t6":"Confirmer",
    "t7":"Le mot de passe est incompatible avec le mot de passe de confirmation",
    "t8":"Mot de passe de transaction",
    "yzm":"Code de vérification",
    "qsryzm":"Veuillez saisir le code de vérification",
    "hqyzm":"Obtenir le code de vérification",
  },
  record: {
    "cbjl":"Enregistrement de dépôt",
    "tbjl":"Enregistrement de retrait",
    "status":"['Non examiné', 'Passé', 'Rejeté']",
    "bhly":"Raison du rejet",
    "ldz":"Adresse",
    "cjsj":"Heure de création",
    "zzsj":"Heure de transfert",
    "czl":"Chaîne de recharge",
    "zrl":"Chaîne de transfert",
    "jyhx":"Hachage de transaction",
  },
  yqm: {
    "wdyqlj":"Mon lien d'invitation",
    "wdyqm":"Mon code d'invitation",
    "schbyq":"Générer une invitation par affiche",
    "bctp":"Enregistrer l'image",
    "qx":"Annuler",
    "fx":"Partager",
    "yqm":"Copier le code d'invitation",
    "bcewmdxc":"Enregistrer le code QR dans l'album",
    "bcbd":"Enregistrer en local",
  },
  "wdtd": {
    "title":"Mon équipe",
    "td":"Équipe",
    "yqhy":"Inviter des amis",
    "ren":"Personne",
    "wdtdzrs":"Le nombre total de membres de mon équipe",
    "uid":"UID:",
    "zh":"Compte:",
    "tdrs":"Taille de l'équipe:",
    "zcsj":"Date d'inscription:",
  },
  "wdyj": {
    "title":"Ma performance",
    "wdyd":"Ma génération",
    "dyj":"Performance",
    "tdzyj":"Performance totale de l'équipe",
    "uid":"UID:",
    "tdrs":"Taille de l'équipe:",
    "yj":"Performance:",
  },
  "zc": {
    "title":"Actifs",
    "zzczh":"Total des actifs équivalents",
    "dh":"Échange",
    "yczc":"Actifs masqués comme 0",
    "xj":"Prix actuel",
    "zh":"Converti",
    "zcmx":"Détails des actifs",
  },
  "duihuang": {
    "title":"Échange",
    "hl":"Taux de change",
    "zf":"Paiement",
    "qbdh":"Échanger tout",
    "ky":"Disponible",
    "dd":"Obtenir",
    "ljdh":"Échanger maintenant",
    "cont":"Le taux de change varie en fonction du montant réel reçu",
    "yebz":"Solde insuffisant",
    "ksslbz":"Quantité disponible insuffisante",
    "qtxje":"Veuillez saisir la quantité",
    "dhcg":"Échange réussi",
    "mrcg":"Achat réussi",
    "mccg":"vendu avec succès",
    "wtcg":"Délégation réussie",
    "ts":"Invite",
    "btcmTips":"Selon les paramètres du contrat intelligent, l'échange GDCC USDT démarrera le 8 août 2023.",
    "qx":"Annuler",
  },
  "sign": {
    "title":"Connectez-vous pour recevoir des pièces",
    "title2":"Récompense de connexion quotidienne",
    "title3":"Récompense de connexion",
    "qd":"Connectez-vous",
    "yqd":"Connecté",
    "hdgz":"Détails de la règle",
    "qdjl":"Enregistrement d'enregistrement",
    "qdcg":"Connexion réussie",
  },
  "langNew": {
    "wd":"Mon",
    "jd":"Emprunt",
    "jghy":"Futures",
    "xbsg":"Achat de devises à Singapour",
    "sylx":"Type d'avantage",
    "syts":"Jours de gains",
    "rsy":"Revenu quotidien",
    "rsy2":"Revenu quotidien",
    "yjdts":"Nombre de jours empruntés",
    "jdsy":"Revenus de prêt",
    "jdsy2":"Revenus de prêt",
    "jdrq":"Date du prêt",
    "qdsy":"Avantages de connexion",
    "tgsy":"Avantage de la promotion",
    "sybl":"Ratio de profit",
    "sybl2":"Ratio de profit",
    "ljcy":"Rejoignez-nous maintenant",
    "zsy":"Revenu total en USDT",
    "jdrz":"Nœud de lien",
    "jiedian":"nœud",
    "qsrje":"Veuillez saisir un nœud",
    "xyb":"Suivant",
    "zhye":"Solde du compte",
    "dzye":"Solde de l'adresse",
    "zhyezh":"Solde du compte (équivalent)",
    "zq":"Période :",
    "zq2":"période",
    "jdsl":"Montant du prêt",
    "yxbd":"Vérification de l'e-mail",
    "qsryxzh":"Veuillez saisir votre compte e-mail",
    "yxgz":"L'adresse e-mail saisie n'est pas conforme aux règles",
    "jxz":"En cours",
    "ywc":"Terminé",
    "day":"Jours",
    "jg":"Prix",
    "zwsj":"Aucune donnée~",
    "wyjb":"Emprunter",
    "fxjl":"Partager la récompense",
    "aqsz":"Paramètres de sécurité",
    "wded":"Ma deuxième génération",
    "wdsd":"Mes trois générations",
    "dbxe":"Limite de transaction unique",
    "tjdd":"Soumettre une commande",
    "tqsh":"Retrait de l'échange",
    "shuhui":"Échange",
    "ljdz":"Adresse du lien",
    "yyqh":"Changement de langue",
    "zxkf":"Service client",
    "syl":"Retour quotidien",
    "zhuanbi":"Gagner des pièces",
    "zbsy":"Gagner des revenus en devises",
    "mc":"Nom",
    "zxj":"Dernier prix",
    "zfb":"Liste en hausse",
    "shouye":"Page d'accueil",
    "gg":"Annonce",
    "rzz":"Certification",
    "yrz":"Authentifié",
    "rzsb":"L'authentification a échoué, veuillez vous authentifier à nouveau",
    "cxrz":"Réauthentification",
    "jymmts":"Veuillez définir un mot de passe de transaction",
  },
  "xbsg":{
    "title":"Newcoin",
    "wdsg":"Détails",
    "scts":"Jours de blocage :",
    "sy":"Restant",
    "ljsg":"S'abonner maintenant",
    "ysk":"Épuisé",
    "xzjdy":"S'abonner maintenant",
    "dy":"S'abonner",
    "fxjg":"Prix d'émission",
    "fxl":"Circulation",
    "ssrq":"Date de cotation",
    "yxqx":"Période de validité",
    "qsrsl":"Veuillez saisir le montant",
    "syl":"Restant",
    "sgrq":"S'abonner",
    "sgsl":"Montant",
    "bz":"Pièce",
    "yebz":"Solde USDT insuffisant",
    "tgsl":"Quantité acceptée",
    "shz":"En cours de révision",
    "wtg":"N'a pas été accepté",
    "ytg":"Admis",
  },
  "wydb":{
    "title":"Emprunter",
    "db":"Emprunter",
    "dbz":"Emprunter",
    "jl":"Enregistrement",
    "jdzq":"Période (jours)",
    "qhk":"À rembourser",
    "ljdb":"Cumulatif (usdt)",
    "dhkbs" :"Paiement en attente",
    "jkje":"Montant du prêt (usdt)",
    "qsrje":"Veuillez saisir le montant",
    "rll":"Taux d'intérêt quotidien",
    "hkfs":"Remboursement",
    "dqych":"Expiré",
    "lx":"Intérêts",
    "fkjg":"Prêteur",
    "tpsc":"Prêt de crédit (téléchargement d'image)",
    "fwxx":"Informations sur le logement",
    "srzm":"Preuve de revenu (relation de travail)",
    "yhmx":"Relevé bancaire",
    "zjz":"Photo d'identité",
    "yd":"J'ai lu et accepté",
    "xy":"Demander un contrat de prêt",
    "sqdb":"Cliquez pour demander des chaînes de prêt",
    "gb":"Fermer",
    "qd":"OK",
    "ts":"Veuillez cocher Demander un contrat de prêt",
    "dbjl":"Enregistrer",
    "hkhth":"Code de commande",
    "wsh":"Non examiné",
    "yfk":"Prêt",
    "sqrq":"Délai de demande",
    "zq":"Cycle",
    "dbsl":"Nombre de côtes",
    "zhke":"Paiement total",
    "yhkxq":"Détails du remboursement",
    "bqyhk":"Remboursable dans la période en cours (USDT)",
    "hktips":"Veuillez vous assurer que le solde est suffisant, si le solde est insuffisant, veuillez d'abord recharger puis rembourser",
    "bj":"Capital",
    "jie":"Emprunter",
    "ljhk":"Rembourser immédiatement",
    "qcz":"Pour déposer",
    "yebzqxcz":"Solde insuffisant, veuillez d'abord recharger puis rembourser",
    "znj":"Frais de retard de paiement",
    "yqts":"Jours de retard",
  },
  "hkxq":{
    "dd":"Commande",
    "fzhkdz":"Copiez l'adresse de remboursement",
    "hkxq":"Détails du remboursement",
    "zlx":"Intérêt total",
    "zhk":"Total des remboursements",
    "hkjg":"Agence de remboursement",
    "qschkpz":"Veuillez télécharger le certificat de remboursement",
    "hkpz":"Certificat de remboursement",
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Commande",
    "cj":"Offre",
    "jj":"Info",
    "sj":"Heure",
    "fx":"Direction",
    "jg":"Prix",
    "sl":"Quantité",
    "mr":"Acheter",
    "mc":"Vendre",
    "mp":"Offre",
    "sp":"Vente",
    "slb":"Qté",
    "fhsj":"Date d'émission",
    "fhsl":"Numéro d'émission",
    "bps":"Livre blanc",
    "gw":"Site Web officiel",
    "fz":"min",
    "xs":"heure",
    "tian":"jours",
    "zhou":"semaine",
    "yue":"mois",
    "gd":"Plus",
    "ft":"Sous-graphique",
    "zt":"Graphique principal",
    "sdt":"Image de profondeur",
    "zx":"Favoris",
    "djck":"Cliquez pour voir",
  },
  "jghy":{
    "jghy":"Options",
    "yxhy":"Perpétuel",
    "mz":"Acheter Long",
    "md":"Acheter Short",
    "gmj":"Prix d'achat",
    "jsj":"Prix de règlement",
    "xj":"Prix actuel",
    "fx":"Direction",
    "sl":"Volume",
    "jgsj":"Délai de livraison",
    "gb":"Fermer",
    "jxxd":"Continuer à passer une commande",
    "cclb":"Liste des commandes",
    "zc":"Actuel",
    "lscc":"Historique",
    "qblx":"Tous",
    "yk":"Profit",
    "ddqr":"Confirmation de commande",
    "dqsj":"Heure d'expiration",
    "jssj":"Heure de livraison",
    "sy":"Profit",
    "tzje":"Prix d'investissement",
    "zdje":"Prix le plus bas 0",
    "kyye":"Solde",
    "kyye2":"Solde",
    "sxf":"Frais :",
    "sxfl":"Frais",
    "jypz":"Nom",
    "jyfx":"Direction",
    "qrxd":"Confirmer",
    "fs":"Ligne",
    "dqye":"Solde actuel",
  },
  "zhjl":{
    "title":"Historique des actifs",
    "cbtb":"Dépôt et retrait",
    "jymx":"Historique des transactions",
    "tgyj":"Commission de promotion",
    "wwc":"Annulé",
    "ywc":"Terminé",
  },
  "tipsNew":{
    "wjmmts":"Récupérer le mot de passe par code de vérification",
    "qscpztp":"Veuillez télécharger l'image du bon",
    "emailgsts":"Les boîtes aux lettres de saisie ne sont pas conformes aux règles",
    "telgsts":"Le numéro de téléphone portable est incorrect",
    "lcmmbyz":"Veuillez confirmer votre mot de passe",
    "zdsl":"Quantité minimale",
    "sldydy":"Quantité supérieure ou égale à",
    "zxtzsl":"Quantité minimale",
    "ddz":"Attente",
    "xs":"Heure",
    "min":"Montant minimum",
    "max":"Montant maximum",
    "yebz":"Solde insuffisant",
    "qsrss":"Veuillez saisir des lots",
    "zdss":"Lots minimum",
    "yjj":"Rejeté",
    "shz":"Rachat",
    "zwkfcz":"Cette devise n'est pas ouverte au dépôt",
    "jiaoge":"Livraison",
    "zhang":"Long",
    "die":"Court",
  },
  "assets": {
    "total":"Conversion d'actifs (USD)",
    "avaiable":"Disponible",
    "conversion":"Conversion",
    "canuse":"Disponible",
    "yczc":"Actifs masqués comme 0",
  },
  "status": {
    "statusText":"['échec','en attente','succès']",
  },
  "langNew2":{
    "zczgz":"Total des actifs",
    "hgx":"Conformité",
    "yszc":"Politique de confidentialité",
    "gywm":"À propos de nous",
    "zb":"Arbitrage IA",
    "mnjy":"Trading simulé",
    "xbzq":"Zone monétaire de Singapour",
    "flzq":"Centre de récompenses",
    "cjmnzhcg":"Créez un compte démo avec succès !",
    "wdzh":"Mon compte",
    "yymnzhts":"Vous avez déjà un compte virtuel, veuillez ne pas vous inscrire à nouveau",
    "tcmnzh":"Quitter le compte démo",
    "mnzhgz":"Évaluation du compte démo",
    "mnzh":"Compte démo",
    "ljdzsb":"Échec de la connexion à l'adresse",
    "ysq":"Autorisé",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"Service de paiement C2C",
    "cjdd":"Créer une commande",
    "mblc":"Dépôt de monnaie fiduciaire",
    "cjydd":"Créer une précommande",
    "xmjfk":"Payer au vendeur",
    "tqhb":"Retirez votre monnaie numérique",
    "ddzt":"Statut de la commande",
    "wdys":"Nos avantages",
    "c1":"Tradez à votre prix préféré",
    "c2":"Achetez et vendez librement des crypto-monnaies à votre prix préféré. Achetez et vendez à partir d'offres existantes, ou créez une annonce commerciale pour définir votre prix idéal.",
    "c3":"Frais de transaction faibles",
    "c4":"Les transactions peer-to-peer (C2C) permettent aux vendeurs de définir librement le mode de paiement qu'ils souhaitent de manière transparente, en achetant et en vendant des crypto-monnaies via plus de 700 modes de paiement, notamment les virements bancaires et les espèces.",
    "c5":"Plusieurs modes de paiement",
    "c6":"Le trading peer-to-peer (C2C) permet aux vendeurs de définir librement le mode de paiement qu'ils souhaitent. Achetez et vendez des crypto-monnaies avec plus de 700 modes de paiement, notamment les virements bancaires et les espèces.",
    "wpp":"Non apparié",
    "ypp":"Apparié",
    "ysx":"Expiré",
    "ddh":"Numéro de commande",
    "mrje":"Montant de l'achat",
    "mrbz":"Devise d'achat",
    "nssdgj":"Pays",
    "qsrnssdgj":"Veuillez saisir le pays",
    "fkrxm":"Nom du payeur",
    "qsrfkrxm":"Veuillez saisir le nom du payeur",
    "yx":"E-mail",
    "qsryx":"Veuillez saisir votre adresse e-mail",
    "mmbz":"Type d'achat",
    "qxzmmbz":"Veuillez sélectionner le type d'achat",
    "qxz":"Veuillez sélectionner",
    "fkfs":"Mode de paiement",
    "qtxfkfs":"Veuillez renseigner le mode de paiement",
    "zh":"Compte",
    "fb":"Type de devise de paiement",
    "qtxfb":"Veuillez indiquer le type de devise de paiement",
    "ngmdje":"Montant de votre achat",
    "qsrje":"Veuillez saisir le montant",
    "wxts":"Rappel chaleureux",
    "dsh":"À examiner",
    "ygq":"Expiré",
    "jcwdwt":"Présentation de C2C",
    "tjpz":"Soumettre un bon",
    "ckje":"Montant correspondant",
    "qsrckje":"Veuillez saisir le montant correspondant",
    "tjzzfb":"Copie du transfert",
    "tjjzzm":"Carte d'identité (recto)",
    "tjjzfm":"Carte d'identité (verso)",
    "psts1":"Faites attention aux points suivants lors de la prise de vue",
    "psts2":"Veuillez noter que la bordure de l'image est complète, la police est claire et la luminosité est uniforme",
    "psts3":"Veuillez ne pas télécharger de photos d'identité qui ne correspondent pas à votre nom",
    "qsczzfb":"Veuillez télécharger une copie du transfert",
    "qscjzzm":"Veuillez télécharger le recto de votre permis de conduire",
    "qscjzfm":"Veuillez télécharger le verso de votre permis de conduire",
    "tj":"Soumettre",
    "je":"Plage limite",
    "ljtg":"Passer la commande",
    "sp":"Comprendre DEFI",
    "xq":"Détails",
    "lxkfppdd":"Contacter le service client pour faire correspondre la commande",
    "szgj":"Pays",
    "qsrszgj":"Veuillez saisir votre pays",
    "fkyhmc":"Nom de la banque de paiement",
    "qsrfkyhmc":"Veuillez saisir le nom de la banque de paiement",
    "dianhui":"Virement bancaire/Virement bancaire international",
    "ccsr":"Saisissez ici",
  },
  "xyf":{
    "title":"Score de crédit",
    "pgsj":"Délai d'évaluation",
  },
  "bbjy":{
    "mr":"Acheter",
    "mc":"Vendre",
    "mai":"Achat",
    "sell":"Vendre",
    "xj":"Limite",
    "sj":"Marché",
    "pk":"Position",
    "jg":"Prix",
    "sl":"Qté",
    "ss":"Quantité",
    "mrl":"Volume d'achat",
    "mcl":"Volume de vente",
    "ky":"Disponible",
    "km":"Disponible",
    "ksell":"Commerciable",
    "jye":"Chiffre d'affaires",
    "dqwt":"Confiance actuelle",
    "lswt":"Confiance historique",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Prix de la commande",
    "ycjl":"Volume de négociation terminé",
    "cjjj":"Prix moyen de la transaction",
    "cd":"Annuler l'ordre",
    "xd":"Ordre",
    "wqcj":"Une transaction terminée",
    "ywc":"Terminé",
    "ycd":"Ordre annulé",
    "zx":"Favoris",
    "scjg":"Prix du marché",
    "fhsj":"Date d'émission",
    "fhsl":"Numéro d'émission",
    "bps":"Livre blanc",
    "gw":"Site officiel",
    "qx":"Annuler",
    "bbjy":"Échange",
  },
  "hyjy":{
    "mai":"Achat",
    "sell":"Vente",
    "kc":"Positions ouvertes",
    "pc":"Positions fermées",
    "cc":"Positions",
    "kp":"Fermer",
    "kpc":"Fermer short",
    "kcc":"Positions",
    "kkd":"Ouvrir long",
    "kpd":"Fermer long",
    "kkk":"Ouvrir short",
    "xj":"Limite",
    "sj":"Marché",
    "xjwt":"Ordre limité",
    "sjwt":"Prix du marché",
    "pk":"Position",
    "jg":"Prix",
    "sl":"Qté",
    "gg":"Levier",
    "tzgg":"Levier de contrôle",
    "ggbs":"Effet de levier",
    "mrl":"Volume d'achat",
    "ky":"Disponible",
    "jye":"Chiffre d'affaires",
    "dqwt":"Contrats en cours",
    "lswt":"Contrats historiques",
    "ptwt":"Contrats ordinaires",
    "dqwtmr":"Contrats en cours (Achat)",
    "dqwtmc":"Contrats en cours (Vente)",
    "hywt":"Contrats contractuels",
    "jj":"Info",
    "wtzl":"Total",
    "wtjg":"Prix du contrat",
    "ycjl":"Volume de négociation terminé",
    "cjjj":"Prix moyen de la transaction",
    "qbcd":"Retirer tous les ordres",
    "cd":"Annuler l'ordre",
    "xd":"Ordre",
    "wqcj":"Une transaction terminée",
    "ywc":"Terminé",
    "ycd":"Ordre annulé",
    "zx":"Favoris",
    "scjg":"Prix du marché",
    "fhsj":"Date d'émission",
    "fhsl":"Numéro d'émission",
    "bps":"Livre blanc",
    "gw":"Site officiel",
    "mrzd":"Long ouvert",
    "mrpk":"Short fermé",
    "mczk":"Short ouvert",
    "mcpd":"Long fermé",
    "mrkdkz":"Long ouvert (haussier)",
    "mrpkkz":"Short fermé (haussier)",
    "mckkkd":"Short ouvert (baissier)",
    "mcpdkd":"Long fermé (baissier)",
    "yxhy":"Contrat perpétuel",
    "dc":"Positions longues",
    "kcjj":"Prix moyen de la position ouverte (BUSDT)",
    "wsxyl":"Bénéfice non réalisé (BUSDT)",
    "ygqpj":"Parité forte estimée (BUSDT)",
    "syl":"Revenu quotidien",
    "cwbzj":"Marge de position (BUSDT)",
    "cw":"Positions (N°)",
    "cwjz":"Valeur de position (BUSDT)",
    "bzjl":"Taux de marge",
    "kpz":"Clôture (N°)",
    "bdzs":"Indice sous-jacent",
    "tzbzj":"Ajuster la marge",
    "zyzs":"Take profit & stop loss",
    "zjbzj":"Augmenter la marge",
    "jsbzj":"Réduire la marge",
    "tyhy":"Contrat d'expérience",
    "ccz":"Position (n°)",
    "cwbzjt":"Marge de position (TBTC)",
    "zdzjbzj":"Augmentation de marge maximale (TBTC)",
    "zjbzjt":"Augmentation de marge (TBTC)",
    "zhang":"Qté",
    "qblx":"Tous les types",
    "qb":"Tous",
    "ccjg":"Prix des positions",
    "ccsl":"Qté des positions",
    "yk":"Profit et perte",
    "ccsj":"Durée des positions",
    "zy":"Take profit",
    "zs":"Stop loss",
    "zje":"Montant total",
    "kcs":"Positions ouvertes Qté",
    "kcjg":"Prix des positions ouvertes",
    "ss":"Lots",
    "hand":"1 lot =",
    "qx":"Annuler",
    "qr":"OK",
  },
  "bbjyNew":{
    "jylx":"Types de",
    "jyze":"Montant",
  },
  "langNew3":{
    "bzxq":"Détails des briques en mouvement",
    "znbz":"IA Quantitative Intelligent Brick Moving",
    "apits":"Connexion transparente aux API de plus de 200 bourses à travers le monde",
    "jr":"Rejoindre",
    "gn":"Fonction",
    "lhjs":"Introduction à la quantification des dividendes",
    "jqrts":"Comment fonctionnent les robots ?",
    "sctj":"Statistiques du marché",
    "scqk":"Conditions du marché",
    "jiaoge":"Livraison",
    "zhang":"Haute",
    "die":"Baisse",
    "sz":"Paramètres",
    "qbcp":"Tous les produits",
    "jrlh":"Rejoindre la quantification de l'IA",
    "sywd":"0 risque, rendements stables",
    "bzbz":"Type de crypto-monnaie",
  },
  "sztkmm":{
    "title":"Définir un mot de passe de retrait",
    "dlmm":"Mot de passe de connexion",
    "dlmmts":"Veuillez saisir le mot de passe de connexion",
    "xmm":"Nouveau mot de passe",
    "mmts":"Longueur du mot de passe 6 chiffres",
    "qrmm":"Confirmer le mot de passe",
    "qr":"OK",
    "qd":"OK",
    "sztkts":"Astuce : veuillez accéder au Centre de sécurité pour définir le mot de passe de la transaction",
  },
  "bzhl":{
    "title":"Dividende",
    "gz":"Règles",
    "tgdd":"Ordre de dépôt fiduciaire",
    "zztgdzj":"Fonds en dépôt",
    "yjjrsy":"Estimation quotidienne",
    "ljsy":"Revenu total",
    "tgzdd":"Ordre en dépôt",
    "cljxcp":"Produits de campagne stratégique",
    "dbxe":"Limite",
    "rsyl":"Taux de rendement quotidien",
    "zq":"Cycle de commande",
    "qmr":"Allez acheter",
    "bbzhzc":"Actifs du compte",
    "zcc":"Actifs totaux (USDT)",
    "dd":"Commandes",
    "buy":"Acheter",
    "jxcp":"Produits phares",
    "ckdd":"Vérifier la commande",
    "gd":"Plus",
    "xzbzts":"Simple et sûr. Les dividendes peuvent être sélectionnés dans plusieurs devises",
    "qtbz":"Autres pièces",
    "dj":"Niveau",
    "cjwt":"Problèmes courants",
    "ddsl":"Quantité commandée",
    "sl":"Montant",
  },
  "bzhlgm":{
    "title":"Bénéfices de la suppression de briques",
    "bzhld":"Bénéfices de la suppression de briques USDT",
    "qtzq":"Cycle USDT de 7 jours",
    "rsyl":"Rapport de rendement quotidien",
    "lczq":"Cycle financier",
    "dbxe":"Limite",
    "pxsj":"Délai de versement des dividendes",
    "mr":"Quotidien",
    "dqfh":"Remboursement à l'échéance",
    "tgzj":"Capital de garde",
    "tqsh":"Rachat anticipé",
    "yjsy":"Revenu anticipé (USDT)",
    "kyzc":"Actifs disponibles (USDT)",
    "cpjs":"À propos de nos produits",
    "tgje":"Entrez le montant",
    "qsrtgje":"Veuillez saisir le montant de garde",
    "qb":"Tous",
    "rm":"Cliquez ici",
    "cpzq":"Cycle du produit",
    "jxr":"Date de calcul des intérêts",
    "jiexr":"Date de règlement des intérêts",
    "yjdzr":"Date d'arrivée estimée",
    "gz":"Connaître les règles et les intérêts",
  },
  "bzhlwdtg":{
    "title":"Statut de la commande",
    "tgz":"En garde",
    "ywc":"Terminé",
    "ysh":"Échange",
    "tgje":"Montant de garde/Durée de garde",
    "rsyl":"Taux de retour quotidien",
    "yhl":"Profité",
    "xdsj":"Heure de la commande",
    "sh":"Échange",
    "ddxq":"Détails de la commande",
    "ddh":"Numéro de commande",
    "syts":"Restant",
    "ddztxq":"Détails du statut de la commande",
  },
  "langNew4":{
    "kp":"Ouverture",
    "zuoshou":"Reçu hier",
    "zg":"Le plus élevé",
    "zd":"Le plus bas",
    "dqjg":"Prix actuel",
    "pcjg":"Cours de clôture",
    "gd":"Ordre en attente",
    "gdj":"Prix de l'ordre en attente",
    "gdjg":"Prix de l'ordre en attente",
    "xfbzj":"Dépôt de garantie requis",
    "ksrfw":"Plage d'entrée disponible",
    "shou":"Lots",
    "fdjyk":"Bénéfice et perte nets flottants",
    "pcsl":"Quantité de clôture",
    "cx":"révoquer",
    "qrpc":"Confirmer pour fermer la position",
    "sx":"Filtre",
    "cz":"Réinitialiser",
    "zdl":"Connu",
    "kccg":"Ouverture d'une position réussie !",
    "xzfx":"Choisir la direction",
    "lx":"Type",
    "xgcc":"Modifier la position",
    "szzyzs":"Définir le stop profit et le stop loss",
    "szhb":"Crypto",
    "gjs":"Métal",
    "yy":"Brut",
    "jy":"Commerce",
    "jmhb":"Crypto",
    "gdsj":"Heure de l'ordre en attente",
    "gdsl":"Quantité de l'ordre en attente",
    "fs":"Heure",
   },
   "deals": {
  	"issue_time":"Heure",
    "issue_number":"Nombre",
    "white_book":"Livre",
    "weburl":"Url",
    "video_url":"Vidéo",
    "introduction":"Info",
    "onhand":"une main égale",
    "position":"Position",
    "leverorder":"Ordres à effet de levier",
    "leverposition":"position à effet de levier",
    "inputprice":"Prix d'entrée",
    "inputmul":"Entrée multiple",
    "selectmul":"Choisir plusieurs",
    "onehand":"une main égale",
    "hand":"Nombre de mains de négociation",
    "marketval":"Valeur de marché",
    "bond":"Obligation",
    "service":"frais de service",
    "balance":"solde",
    "type":"Type",
    "risk":"Taux de risque",
    "total":"bénéfice total",
    "onekey":"fermeture",
    "makemore":"(Long)",
    "makeless":"(Short)",
    "current":"Ordres ouverts",
    "all":"Tous",
    "weing":"En commission",
    "tding":"Trading",
    "ping":"Clôture",
    "pied":"Clôturé",
    "ceiled":"retiré",
    "weprice":"prix de la commission",
    "oprice":"Prix d'ouverture",
    "nowprice":"Prix actuel",
    "zyprice":"Prix stop des gains",
    "zsprice":"Prix stop-loss",
    "canbond":"Marge disponible",
    "optime":"Heure d'ouverture",
    "pgtime":"Heure de fermeture",
    "znum":"Quantité convertie",
    "gprice":"Frais de nuit",
    "pcang":"Clôture",
    "revoke":"Retrait",
    "fee":"Frais",
    "you":"Prix optimal du marché",
  },
  "zyzs":{
    "title":"Take profit et stop loss",
    "zy":"Take profit",
    "zs":"Stop loss",
    "qsrzyjg":"Veuillez saisir un prix Take Profit",
    "qsrzsjg":"Veuillez saisir un prix stop loss",
    "cfjglx":"Type de prix de déclenchement",
    "zsjg":"Prix de l'indice",
    "scjg":"Prix du marché",
    "pcfs":"Méthodes de clôture des positions",
    "kpcw":"Clôture",
    "qbcw":"Toutes les positions",
    "wxts":"Remarque :",
    "cont":"Les positions de clôture du prix du marché peuvent créer la possibilité de ne pas passer un ordre au prix du marché ou de réussir à prendre un profit/stop loss en raison de fortes fluctuations du marché et d'autres problèmes.",
    "qr":"OK",
  },
  "level1": {
    "name":"Nom réel",
    "idcard":"Type de certificat",
    "address":"Adresse de résidence actuelle",
    "bank_number":"Numéro de banque",
    "wc":"OK",
    "name_nodata":"Le nom ne peut pas être vide",
    "id_card_nodata":"Le numéro de certificat ne peut pas être vide",
    "address_nodata":"L'adresse ne peut pas être vide",
    "bank_number_nodata":"Le numéro de carte bancaire ne peut pas être vide",
    "input-username":"Veuillez saisir votre vrai nom",
    "zjhm":"Numéro de certificat",
    "input-idcard":"Veuillez saisir votre numéro de certificat",
    "input-address":"Veuillez saisir votre adresse",
    "zjlx":"Types de pièces d'identité valides",
    "qxzzjlx":"Veuillez sélectionner les types de pièces d'identité valides",
    "sfz":"Carte d'identité",
    "hz":"Passeport",
    "jsz":"Permis de conduire",
    "lxz":"Certificat pour études à l'étranger",
    "zfbzh":"Compte Alipay",
    "qsrzfbzh":"Veuillez saisir votre compte Alipay",
    "khh":"Ouverture de compte",
    "qsrkhh":"Veuillez saisir votre compte bancaire",
    "yhkh":"Numéro de carte bancaire",
    "qsryhkh":"Veuillez saisir votre numéro de carte bancaire",
    "zfzh":"Compte de paiement",
    "qxzzfzh":"Veuillez choisir un compte de paiement",
    "gjlb":"Liste des pays",
    "qxzgjlb":"Veuillez sélectionner un pays/une région",
    "gjhdq":"Pays/Région",
    "qtxgj":"Veuillez indiquer le pays/la région",
  },
  "gjrz":{
    "title":"Authentification KYC",
    "t1":"1. Les images de moins de 8 Mo et aux formats JPG, JPEG ou PNG sont prises en charge.",
    "t2":"2. Les photos des documents d'identité doivent être claires et ne doivent pas être modifiées ou bloquées. La photo personnelle, le numéro du document et le nom du titulaire du document doivent être clairement visibles.",
    "t3":"3. Les photos doivent être prises sans couvre-chef et il est recommandé de ne pas utiliser de maquillage. Les traits du visage du titulaire du document doivent être clairs et reconnaissables, et ses bras doivent être entièrement exposés.",
    "t4":"OK",
    "bh":"Rejeter",
    "shz":"En cours de révision",
    "shtg":"Approuvé",
    "nyrzcg":"Vous avez été certifié avec succès",
    "sczjz":"Télécharger des photos d'identité",
    "sczjzmz":"Télécharger une photo du recto du document d'identité",
    "sczjbmz":"Télécharger une photo du verso du document d'identité",
    "scgrqmz":"Télécharger des documents et une signature personnelle",
    "wdtjr":"Mon parrain",
    "tjrid":"ID du parrain",
    "qsrtjrid":"Veuillez saisir l'ID du parrain",
    "idbcz":"L'ID du parrain n'existe pas",
    "tjcg":"Soumission réussie",
    "tjridts":"L'ID du parrain ne peut pas être renseigné par vous-même",
    "qsrzh":"Veuillez saisir un compte",
    "dl":"Connexion",
    "jc":"Médiocre",
    "yb":"Général",
    "yx":"Excellent",
    "ldjsqh":"LME Futures",
    "wh":"Foreign Exchange",
  },
  "newReg":{
    "sjh":"Mobile",
    "yx":"E-mail",
    "yqm":"Code d'invitation",
    "yqm2":"Code d'invitation (facultatif)",
    "cjzh":"Créer un compte",
    "sysjhzyx":"S'inscrire avec un numéro de téléphone portable/e-mail",
    "sj":"Mobile",
    "yhxy":"",
    "yhxy2":"J'ai lu et j'accepte les  et  ",
    "hmyzh":"Vous n'avez pas encore de compte ?",
    "qzc":"S'inscrire",
    "qbdl":"Connexion au portefeuille",
    "qyqbfw":"Veuillez utiliser l'application Wallet pour accéder",
    "dc":"Se déconnecter",
    "cycs":"Nombre de participations"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/fr.js